import swal from "sweetalert2";

export const confirmAction = async(verbiage, action) => {
	try {
		const result = await swal.fire({
			title: "Confirm Action",
			html: verbiage,
			showCloseButton: true,
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#8CC541",
			confirmButtonText: "Yes"
		});

		if(result.value === true) {
			return action();
		}

		return Promise.resolve(false);
	}
	catch(error) {		
		return Promise.resolve(false);
	}
};